import { initAnalytics, getAnalyticsSync } from "@/lib/firebase";
import { logEvent as firebaseLogEvent, Analytics } from "firebase/analytics";
import { useEffect, useState } from "react";

export const useAnalytics = () => {
  const [analytics, setAnalytics] = useState<Analytics | null>(
    getAnalyticsSync()
  );

  useEffect(() => {
    // Ensure analytics is loaded
    initAnalytics().then(setAnalytics);
  }, []);

  const logEvent = (eventName: string, eventParams?: Record<string, any>) => {
    if (analytics) {
      firebaseLogEvent(analytics, eventName, eventParams);
    }
  };

  const logPageView = (pageName: string, pageLocation?: string) => {
    if (analytics) {
      firebaseLogEvent(analytics, "page_view", {
        page_title: pageName,
        page_location: pageLocation ?? window.location.href,
        page_path: window.location.pathname
      });
    }
  };

  return {
    logEvent,
    logPageView,
    isReady: !!analytics
  };
};

// Common event logger functions
export const logLogin = async (method: string) => {
  const analytics = await initAnalytics();
  if (analytics) {
    firebaseLogEvent(analytics, "login", { method });
  }
};

export const logSignUp = async (method: string) => {
  const analytics = await initAnalytics();
  if (analytics) {
    firebaseLogEvent(analytics, "sign_up", { method });
  }
};

export const logFileUpload = async (fileType: string, fileSize: number) => {
  const analytics = await initAnalytics();
  if (analytics) {
    firebaseLogEvent(analytics, "file_upload", {
      file_type: fileType,
      file_size: fileSize
    });
  }
};
